import React from "react"
import styles from "./notFunnel.module.css"
import { BsFunnel } from "react-icons/bs"

const NotFunnel = () => {
    return (
        <div className={styles.progressSetup}>
            <div className={styles.icon} aria-hidden="true"><BsFunnel /></div>
            <div className={styles.text}>
                <span className={styles.label}>Funis</span>
                <h1 className={styles.title}>Nenhum funil disponível</h1>
                <p className={styles.description}>Peça ao administrador da conta para configurar um funil e liberar o acesso para a sua equipe.</p>
            </div>
        </div>
    )
}

export default NotFunnel
